import UploadDocumentsModal from "./UploadDocumentsModal"

export default UploadDocumentsModal
